import React, { useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { Title, SubTitle, LeftSide, Column, Back, InputContainer, StyledInput } from './ForgotPasswordPage.styles';
import Button from '../../../components/utils/Button/Button';
import { ReactComponent as Logo } from '../../../assets/icons/logoBlack.svg';
import { ReactComponent as LeftChevron } from '../../../assets/icons/chevronLeft.svg';
import { useNavigate } from 'react-router-dom';
import MainContainer from '../../../components/MainContainer/MainContainer';
import { useDispatch, useSelector } from 'react-redux';
import { sendRecoveryCodeForgotPassword } from '../../../store/slice/auth/asyncThunks';
import { toast } from 'react-toastify';
import { selectSendRecoveryCodeForgotPasswordPending, setEmailInput } from '../../../store/slice/auth/slice';
import { notifyError } from '../../../utils/notify';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [isEmailValid, setIsEmailValid] = useState(false);
  const loading = useSelector(selectSendRecoveryCodeForgotPasswordPending);

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = e => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setIsEmailValid(validateEmail(newEmail));
  };

  return (
    <MainContainer>
      <LeftSide>
        <Logo width={110} height={58} />

        <Column>
          <Back onClick={() => navigation(-1)}>
            <LeftChevron />
          </Back>
          <Title>Forgot Password</Title>
          <SubTitle>Please enter email, and we will send you recovery code</SubTitle>
        </Column>
        <InputContainer>
          <StyledInput placeholder="Email Address" value={email} onChange={handleEmailChange} />
        </InputContainer>

        <Button
          width
          disabled={!isEmailValid || loading}
          loading={loading}
          title={'Continue'}
          onClick={() => {
            dispatch(sendRecoveryCodeForgotPassword(email))
              .unwrap()
              .then(() => {
                dispatch(setEmailInput(email));
                navigation('/recovery-code');
              })
              .catch(err => {
                console.log(err);
                notifyError(err.message);
              });
          }}
        />
      </LeftSide>
    </MainContainer>
  );
};

export default ForgotPasswordPage;
